import { render, staticRenderFns } from "./PreparationExpedition.vue?vue&type=template&id=328d2389&scoped=true&"
import script from "./PreparationExpedition.vue?vue&type=script&lang=js&"
export * from "./PreparationExpedition.vue?vue&type=script&lang=js&"
import style0 from "./PreparationExpedition.vue?vue&type=style&index=0&id=328d2389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d2389",
  null
  
)

export default component.exports